import { mixinSafeArea } from '@monorepo/styles';
import { IcArrowDown, LoadingDark, Typography } from '@musinsa/mds';
import styled from 'styled-components';

import type { GiftProduct } from '@/shared/@types';
import type { FC } from 'react';

import { gtmGift } from '@/shared/log/ga4';
import { ProductItem } from '@/shared/ui/gift-detail/ProductItem';
import { MdsButton } from '@/shared/ui/mds';

type ProductGridProps = {
  products: GiftProduct[];
  hasMore: boolean;
  onLoadMore: () => void;
  isLoading?: boolean;
};

const ProductGrid: FC<ProductGridProps> = ({
  products,
  hasMore,
  onLoadMore,
  isLoading = false,
}) => {
  if (products.length === 0) return null;

  return (
    <section>
      <S.Header>
        <Typography variant="title18pxMed" colorScheme="black">
          적용 상품
        </Typography>
      </S.Header>

      <S.Grid>
        {products.map((product, idx) => (
          <S.GridItem key={product.goodsNo}>
            <ProductItem idx={idx} product={product} />
          </S.GridItem>
        ))}
      </S.Grid>

      {hasMore && (
        <S.LoadMoreWrapper>
          <S.LoadMoreButton variant="secondary" size={44} onClick={onLoadMore} disabled={isLoading}>
            {isLoading ? (
              <LoadingDark size="size12x12" />
            ) : (
              <S.LoadMoreText {...gtmGift.More()}>
                <Typography variant="body14pxReg" colorScheme="black">
                  상품 더보기
                </Typography>
                <S.ArrowIcon strokeColor="gray-600" />
              </S.LoadMoreText>
            )}
          </S.LoadMoreButton>
        </S.LoadMoreWrapper>
      )}
    </section>
  );
};

const S = {
  Header: styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
  `,
  Grid: styled.div`
    display: flex;
    flex-wrap: wrap;
  `,
  GridItem: styled.div`
    width: 33.3%;
    display: flex;
    flex-direction: column;
  `,
  LoadMoreWrapper: styled.div`
    /* margin: 18px 0 48px 0; */
    margin: 18px 0 72px;
    padding: 0 16px;
    ${mixinSafeArea('margin-bottom', 72)};
  `,
  LoadMoreButton: styled(MdsButton)`
    width: 100%;
  `,
  LoadMoreText: styled.span`
    display: flex;
    align-items: center;
    gap: 2px;
  `,
  ArrowIcon: styled(IcArrowDown)`
    width: 12px;
    height: 12px;
  `,
};

export { ProductGrid };
